<template>
	<header class="s-header">
		<div class="header-logo">
			<a class="site-logo" href="#home"><i class="icon-wog-project-wog"></i></a>
		</div>

		<nav class="header-nav">
			<a href="javascript:void(0);" class="header-nav__close tt" :title="$t('buttons.headerClose')"><span>{{ $t('buttons.headerClose') }}</span></a>

			<div class="header-nav__content">
				<h3 class="tt">{{ $t('titles.headerNavigation') }}</h3>

				<ul class="header-nav__list">
					<li class="current"><a class="smoothscroll" href="#home" v-html="$t('titles.menuHome')"></a></li>
					<li><a class="smoothscroll"  href="#about" v-html="$t('titles.menuAbout')"></a></li>
					<li><a class="smoothscroll"  href="#status" v-html="$t('titles.menuStatus')"></a></li>
					<li><a class="smoothscroll"  href="#installation-addons" v-html="$t('titles.menuInstallationAddons')"></a></li>
					<li><a class="smoothscroll"  href="#installation-teamspeak" v-html="$t('titles.menuInstallationTeamspeak')"></a></li>
					<li><a class="smoothscroll"  href="#installation-run" v-html="$t('titles.menuInstallationRun')"></a></li>
					<li><a class="smoothscroll"  href="#advices" v-html="$t('titles.menuAdvices')"></a></li>
					<li><a class="smoothscroll"  href="#faq" v-html="$t('titles.menuFaq')"></a></li>
					<li><a class="smoothscroll"  href="#video" v-html="$t('titles.menuVideos')"></a></li>
					<li><a class="smoothscroll"  href="#gallery" v-html="$t('titles.menuGallery')"></a></li>
					<li><a class="smoothscroll"  href="#quotes" v-html="$t('titles.menuQuotes')"></a></li>
				</ul>

				<p v-html="$t('texts.menuWarning', {url: 'https://wogames.info/new-rules/wog-server-rules/'})"></p>

				<SocialButtons/>
			</div>
		</nav>

		<WidgetLanguagepicker/>

		<a class="header-menu-toggle" href="javascript:void(0);">
			<span class="header-menu-text tt">{{ $t('titles.headerMenu') }}</span>
			<span class="header-menu-icon"></span>
		</a>
	</header>
</template>

<script>
	import SocialButtons from '../socialButtons/Buttons';
	import WidgetLanguagepicker from "../widgets/Languagepicker";
	export default {
		name: 'SectionHeader',
		components: {WidgetLanguagepicker, SocialButtons}
	}
</script>



// WEBPACK FOOTER //
// src/components/sections/Header.vue